import React from 'react'
import './templat.css'
import { Timeline } from 'primereact/timeline';
import {Button} from 'primereact/button';   
import { Card } from 'primereact/card';
import { Link } from 'react-router-dom';
        
const Templat = () => {
  const events = [
    { status: 'Get Informed ', date: '15/10/2020 10:30', icon: 'pi pi-info-circle', color: '#9C27B0' },
    { status: 'Get a Customized Guide', date: '15/10/2020 14:00', icon: 'pi pi-cog', color: '#673AB7' },
    { status: 'Ask the Chatbot', date: '15/10/2020 16:15', icon: 'pi pi-shopping-cart', color: '#FF9800' },
    { status: 'Next Step', date: '16/10/2020 10:00', icon: 'pi pi-check', color: '#607D8B' }
];
const customMarker = (item) => {
  return (
      <span className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1" style={{ backgroundColor: item.color }}>
          <i className={item.icon}></i>
      </span>
  );
};

  return (
    <div className="content">
            <div className="content1">
                <div className='content1-text'>
                <h1>Start your Business in Albania</h1>
                <h3>Your gateway to success in a thriving European market</h3>
                <p>"We help foreign entrepreneurs and digital nomads start and grow their businesses in Albania by providing instant AI-powered legal and tax guidance—saving them time, money, and confusion"</p>
                </div>
                <div className='content1-image'>
                  <img 
                    src="https://images.pexels.com/photos/16142688/pexels-photo-16142688/free-photo-of-view-of-the-albanian-flag-and-the-gjirokaster-fortress-with-mountains-in-the-background.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" 
                    alt="Albanian landscape with flag" 
                    loading="lazy"
                  />
                </div>
            </div>
            <div className="content2">
      
                <h2 style={{fontWeight:"400", marginBottom:"1rem"}}>Why Albania?</h2>

              <div className='content2-cards'>
                <Card className='card flex-1'>
                <span className='iconholder'><img src={`${process.env.PUBLIC_URL}/Images/buildings.png`} alt="" /></span>
                <h4>Business-Friendly Environment</h4>
                <p>Albania offers a supportive regulatory framework, minimal bureaucracy, and a growing economy, making it easy for entrepreneurs to start and grow their businesses.</p>
                </Card>
                <Card className='card flex-1'>
                <span className='iconholder'><img src={`${process.env.PUBLIC_URL}/Images/money-bag.png`} alt="" /></span>
                <h4>Low Taxes & Business Costs</h4>
                <p>With one of the lowest corporate tax rates in Europe and affordable operational costs, Albania is a cost-effective destination for startups and businesses.</p>
                </Card>
                <Card className='card flex-1'>
                <span className='iconholder'><img src={`${process.env.PUBLIC_URL}/Images/globe.png`} alt="" /></span>
                <h4>Strategic Location</h4>
                <p>ositioned at the crossroads of Europe and the Balkans, Albania provides easy access to key markets, making it an ideal hub for international trade and investment.</p>
                </Card>
                <Card className='card flex-1'>
                <span className='iconholder'><img src={`${process.env.PUBLIC_URL}/Images/rocket.png`} alt="" /></span>
                <h4>Vibrant Startup Ecosystem</h4>
                <p>A growing community of entrepreneurs, incubators, and investment opportunities fosters innovation and business growth in Albania.</p>
                </Card>
              </div>
            </div>
            <div className="content3">
              <h2 style={{fontWeight:"400", marginBottom:"2rem"}}>A Step-By-Step Guide on How to Get Started</h2>
              <div className="card flex flex-wrap gap-6">
              <Timeline value={events} layout="horizontal" align="top"      className="w-full"  marker={customMarker} content={(item) => item.status} /></div>
            </div>
            <div className='content4'>
              <h2 style={{fontWeight:"400", marginBottom:"2rem"}}>Why You Should Pick Us?</h2>
            
              <ul>
                <li>Instant AI-powered responses</li>
                <li>Affordable compared to lawyers</li>
                <li>Available 24/7</li>
              </ul>
       
              <span style={{fontStyle:'italic'}}>"Unlike traditional law firms and consultants, AlbaBiz AI provides instant, AI-driven legal and tax guidance—so foreign entrepreneurs can confidently start their business in Albania without expensive fees or long delays."
              </span>
            </div>
            <div className='content5'>
              <h2 style={{fontWeight:"400", marginBottom:"2rem"}}>Ready to Take the First Step?</h2>
              <p>Starting your business in Albania is closer than you think. With endless opportunities and a supportive environment, the time to act is now. Let us guide you through each step of your journey to success.</p>
              <h5>Make your business dream a reality today.</h5>
              <Link to='/steps/step1'>
              <Button>Get Started Now</Button>
              </Link>
            </div>
            </div> 
  )
}

export default Templat